import { t } from '@if/core/i18n'
import { PageContainer } from '@if/mui'
import { ManageUsersContent } from './ManageUsersContent'

const ManageUsersPage = () => (
  <PageContainer title={t('nav.manageUsers')} subtitle={t('manageUsers.subtitle')}>
    <ManageUsersContent />
  </PageContainer>
)

export default ManageUsersPage
